import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import Trns, { useTranslate } from 'src/localization/Trns'
import { TransactionStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface TransactionStatusFilterProps {
  statusSet: Set<string>
  handleStatusSelection: (status: string) => Set<string>
}

const TransactionStatusFilter: React.FC<TransactionStatusFilterProps> = ({
  statusSet,
  handleStatusSelection,
}) => {
  const translate = useTranslate()
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Transaction Status'} />
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="transaction-status-cleared"
          onChange={(): void => {
            handleStatusSelection(TransactionStatus.Cleared)
          }}
          checked={statusSet.has(TransactionStatus.Cleared)}
          aria-label={translate('Cleared')}
        />
        <label
          htmlFor="transaction-status-cleared"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          <Trns source={'Cleared'} />
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="transaction-status-declined"
          onChange={(): void => {
            handleStatusSelection(TransactionStatus.Declined)
          }}
          checked={statusSet.has(TransactionStatus.Declined)}
          aria-label={translate('Declined')}
        />
        <label
          htmlFor="transaction-status-declined"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          <Trns source={'Declined'} />
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="transaction-status-pending"
          onChange={(): void => {
            handleStatusSelection(TransactionStatus.Pending)
          }}
          checked={statusSet.has(TransactionStatus.Pending)}
          aria-label={translate('Pending')}
        />
        <label
          htmlFor="transaction-status-pending"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          <Trns source={'Pending'} />
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="transaction-status-reversal"
          onChange={(): void => {
            handleStatusSelection(TransactionStatus.AuthReversal)
          }}
          checked={statusSet.has(TransactionStatus.AuthReversal)}
          aria-label={translate('Reversal')}
        />
        <label
          htmlFor="transaction-status-reversal"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          <Trns source={'Reversal'} />
        </label>
      </div>
    </div>
  )
}

export default TransactionStatusFilter
